export default __webpack_public_path__ + "static/spiritual-maya-hotel-2-2a558fecbbd2d8e3e4c7804935e1d12a.jpg";